<template>
    <div>
        <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <div class="hs-screen-row">
                <Input v-model="params.roleName" placeholder="名称" clearable style="width: 200px"/>
            </div>

            <div class="hs-screen-row">
                <Select v-model="params.isDisable" placeholder="状态" clearable style="width:200px">
                    <Option value="">全部</Option>
                    <Option value="0">已启用</Option>
                    <Option value="1">已禁用</Option>
                </Select>
            </div>

            <div class="hs-screen-row">
                <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                            separator=" ~ " split-panels transfer
                            placeholder="创建时间" style="width: 200px"></DatePicker>
            </div>
            <div class="hs-screen-row">
                <Button type="primary" @click="findRoleList">查询</Button>
            </div>
            <div class="hs-screen-row">
                <Button @click="resetScreen">重置</Button>
            </div>
        </Card>

        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <!--标题-->
            <div slot="title">
                <div class="hs-screen-box">
                    <div>角色列表</div>
                    <div>
                        <ButtonGroup>
                            <Button @click="findRoleList">
                                <Icon type="md-refresh" size="15"/>
                            </Button>
                            <Button @click="showAdminOpe(2)">新增角色</Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
            <!--表格数据-->
            <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

                <template slot-scope="{ row, index }" slot="isDisable">
                    <Tag color="green" v-if="row.isDisable === 0" size="default">启用</Tag>
                    <Tag color="volcano" v-if="row.isDisable === 1" size="default">禁用</Tag>
                </template>

                <template slot-scope="{ row }" slot="action">
                    <Button type="success" size="small" style="margin-right: 5px" @click="showAdminOpe(1, row)">查看
                    </Button>
                    <Button type="primary" size="small" style="margin-right: 5px" @click="showAdminOpe(3, row)">编辑
                    </Button>

                    <Dropdown transfer trigger="click">
                        <Button size="small">
                            <Icon type="ios-more" size="22"/>
                        </Button>
                        <DropdownMenu slot="list">
                            <DropdownItem v-if="row.isDisable === 0" @click.native="isDisableRole(row)">禁用
                            </DropdownItem>
                            <DropdownItem v-if="row.isDisable === 1" @click.native="isDisableRole(row)">启用
                            </DropdownItem>
                            <DropdownItem @click.native="isDelRole(row)">删除</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </template>
            </Table>
            <!--分页-->
            <div class="hs-page">
                <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                      @on-page-size-change="changePageSize"/>
            </div>
        </Card>
        <!--角色操作-->
        <role-ope ref="roleOpe" @changeDate="findRoleList"></role-ope>
    </div>
</template>

<script>
    import hsBreadcrumb from '@/components/hs-breadcrumb';
    import roleOpe from './components/role-ope';

    export default {
        name: "role",
        data() {
            return {
                total: 0,
                isTableLoading: false,
                dateInit: '',
                params: {
                    page: 1,
                    rows: 10,
                    roleName:'',
                    isDisable:'',
                    startTime: '',
                    endTime: ''
                },
                // 表格列
                columns: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'ID',
                        minWidth: 120,
                        key: 'adminRoleId'
                    },
                    {
                        title: '名称',
                        minWidth: 120,
                        key: 'roleName'
                    },
                    {
                        title: '状态',
                        slot: 'isDisable',
                        align: 'center',
                        width: 120
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                        width: 150
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 180,
                        align: 'center'
                    }
                ],
                // 表格数据
                data: [],
                // 面包屑
                breadcrumb: [
                    {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
                    {name: '系统管理', url: '', icon: '', size: 0},
                    {name: '角色', url: '', icon: '', size: 0}
                ]
            }
        },
        created() {
            // 管理员-角色列表查询
            this.findRoleList();
        },
        methods: {
            // 管理员-角色列表查询
            findRoleList() {
                this.isTableLoading = true;
                this.axios.post('/adminRole/findRoleList', this.params).then(res => {
                    console.log(res);
                    this.isTableLoading = false;
                    if (res.status == 200) {
                        this.total = res.data.total;
                        this.data = res.data.rows;
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '角色列表查询接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 显示操作模态框
            showAdminOpe(type, row) {
                /**
                 * type判断
                 * 1.查看 2.新增 3.编辑
                 */
                this.$refs.roleOpe.show(type, row);
            },
            // 是否删除角色
            isDelRole(row) {
                console.log(row)
                this.$Modal.confirm({
                    title: `是否删除角色${row.roleName}？`,
                    onOk: () => {
                        // this.$Message.info('您点击了确定.');
                        this.roleDelete(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 是否禁用角色
            isDisableRole(row) {
                // console.log(row)
                this.$Modal.confirm({
                    title: `是否${row.isDisable ? '开启' : '禁用'}角色${row.roleName}？`,
                    onOk: () => {
                        this.roleDisable(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 删除角色
            roleDelete(row) {
                this.$Spin.show();
                this.axios.post('/adminRole/roleDelete', {
                    adminRoleId: row.adminRoleId
                }).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findRoleList();
                    }
                    if (res.status == 201) {
                        // this.$Message.error(res.msg);
                        this.$Notice.error({
                            title: '删除角色失败',
                            desc: res.msg
                        });
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '删除角色接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 禁用或开启角色
            roleDisable(row) {
                this.$Spin.show();
                this.axios.post('/adminRole/roleDisable', {
                    adminRoleId: row.adminRoleId,
                    isDisable: row.isDisable ? 0 : 1
                }).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findRoleList();
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '禁用角色接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 重置筛选条件
            resetScreen() {
                this.params.roleName = '';
                this.params.isDisable = '';
                this.params.startTime = '';
                this.params.endTime = '';
                this.dateInit = '';
            },
            // 日期条件赋值
            changeDate(e) {
                this.params.startTime = e[0];
                this.params.endTime = e[1];
            },
            // 改变页数
            changePage(e) {
                this.params.page = e;
                this.findRoleList();
            },
            // 改变页容量
            changePageSize(e) {
                this.params.rows = e;
                this.findRoleList();
            }
        },
        components: {
            hsBreadcrumb,
            roleOpe
        }
    }
</script>

<style scoped>

</style>